import React from 'react'
import { View, TextInput, StyleSheet, Dimensions } from 'react-native'
import Colors from '../../../../constants/Colors'
import { useAppSelector, useAppDispatch } from '../../../../state/hooks'
import { setCheckoutState } from '../../../../state/Slices/checkoutSlice'
import { AddPromo } from '../AddPromo/AddPromo'
import ApplyGiftCardForm from '../PaymentMethods/ApplyGiftCardForm'
import ReviewAddress from './ReviewAddress'
import {
	Box,
	Text,
	Spread,
	Stack,
	Divider,
	Button,
	Inline,
} from '../../../../components/DesignSystem'
import OrderSummary from '../../Components/OrderSummary'
/**
 * Screen to choose the desired receipt options & text updates
 * Email (through sendgrid), text (through twilio), or print (alerts R.M. to print receipt with order)
 */
const ReviewOrder = ({
	promoFuncData,
	prices,
	hideOptions = false,
	useProductCheckout = false,
}) => {
	const dispatch = useAppDispatch()
	const { isDelivery } = useAppSelector(state => state.persisted)
	const { enableGiftCard } = useAppSelector(state => state.settings)
	const { orderNote, showOrderNotes } = useAppSelector(state => state.checkout)

	return (
		<>
			<View style={styles.componentContainer}>
				<View style={{ width: '100%' }}>
					<Stack gap="xxl">
						<Stack gap="lg">
							<Text weight="semibold" tone="tertiary" level="large">
								CONFIRM YOUR ORDER
							</Text>
							<OrderSummary prices={prices} useProductCheckout={useProductCheckout} />
						</Stack>
						<Divider />
						{!useProductCheckout && isDelivery && (
							<>
								<ReviewAddress />
								<Divider />
							</>
						)}

						{!hideOptions && (
							<>
								<AddPromo promoFuncData={promoFuncData} />
								<Divider />
								{enableGiftCard && (
									<>
										<ApplyGiftCardForm totalAmount={prices.total} />
										<Divider />
									</>
								)}

								<Stack gap="sm">
									<Text level="subheadline" weight="medium" tone="tertiary">
										ANY NOTES?
									</Text>

									{!showOrderNotes ? (
										<Inline gap="sm">
											<Button
												onPress={() => {
													dispatch(setCheckoutState({ showOrderNotes: true }))
												}}
												variant="ghost"
												size="medium"
												weight="regular"
												type="link"
											>
												Add a note
											</Button>
										</Inline>
									) : (
										<TextInput
											returnKeyType="done"
											style={styles.noteInput}
											multiline
											numberOfLines={2}
											placeholderTextColor={Colors.greyscale[6]}
											placeholder="Optional notes"
											value={orderNote}
											onChangeText={value => {
												dispatch(setCheckoutState({ orderNote: value }))
											}}
											maxLength={200}
										/>
									)}
								</Stack>
							</>
						)}
					</Stack>
				</View>
			</View>
		</>
	)
}

const styles = StyleSheet.create({
	noteInput: {
		borderWidth: 1.5,
		borderColor: Colors.greyscale[3],
		borderRadius: 8,
		padding: 12,
		height: 65,
		marginTop: 10,
		textAlignVertical: 'top',
	},
	componentContainer: {
		flex: 1,
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		marginTop: 15,
		borderRadius: 25,
	},
})

export default ReviewOrder
